<template>
  <b-card>
      <!-- Form -->
      <b-form
        class="p-2"
      >
        <b-row>
        <b-col sm="12">
          <b-form-group
            label="Notifikasi"
            label-for="nama"
          >
            <b-form-input
              v-model="userData.nama"
              name="nama"
              placeholder="nama"
              :disabled="true"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="Label Button"
            label-for="button_caption"
          >
            <b-form-input
              v-model="userData.button_caption"
              name="button_caption"
              placeholder="button_caption"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="URL Button"
            label-for="url_button"
          >
            <b-form-input
              v-model="userData.url_button"
              name="url_button"
              placeholder="url_button"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="Konten"
            label-for="konten"
          >
            <b-form-textarea
              v-model="userData.konten"
              name="konten"
              placeholder="konten"
              rows="3"
            />
          </b-form-group>
        </b-col>
      </b-row>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            @click="updateData"
          >
            Simpan
          </b-button>
        </div>

      </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol, BBadge,
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback,
  BFormSpinbutton, BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { required, alphaNum, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import moment from 'moment'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormTextarea,
  },
  directives: {
    Ripple,
  },
  data() {
    var userData = this.rowData.data
    return {
      userData,
      required,
      alphaNum,
      email,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async updateData() {
      store.dispatch('notifikasi-email/updateData', this.rowData.data)
        .then(response => {
          this.makeToast('success', 'Simpan Data Notifikasi Email Berhasil Dilakukan')
          setTimeout(() => {
            this.$router.push({name: 'notifikasi-email'})
          }, 3000);
        })
        .catch(error => {
        })
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate(value, format) {
      return moment(String(value)).format(format)
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        // title: `Variant ${variant || 'default'}`,
        title: 'Notifikasi Email',
        variant,
        solid: true,
        autoHideDelay: 3000,
      })
    },
    mappingSelectOptionIds(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.ids,
          })
        })
      }
    },
  },
}
</script>

<style>

</style>
